export const APP_IMAGES = {
    BACKGROUND: require("../img/new_login_bg.png"),
    LOGO: require("../img/Lena.png"),
    LOGO_FULL: require("../img/3083_Logo_Programa_Lena.jpg"),
};
